import { render, staticRenderFns } from "./ProfileSettingsEmailNotifications.vue?vue&type=template&id=319414ae&scoped=true&"
import script from "./ProfileSettingsEmailNotifications.vue?vue&type=script&lang=ts&"
export * from "./ProfileSettingsEmailNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileSettingsEmailNotifications.vue?vue&type=style&index=0&id=319414ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319414ae",
  null
  
)

export default component.exports